import { PRIVATE_API_ROUTES } from "../constants";
import Http from "./http-service";
import { getLocalizedMessage } from "../UtilityFunctions/utils";
import { showNotification } from "../UtilityFunctions/notification";
import { BAD_REQUEST } from "../constants/errorConstants";

class MyAccountServices {
  static async changePassword({ body, intl }) {
    return Http.put(PRIVATE_API_ROUTES.CHANGE_PASSWORD, body)
      .then(({ data }) => {
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "account.changePassword.successMsg")
        );
        return Promise.resolve(data);
      })
      .catch((error) => {
        if (error?.response?.data?.code === BAD_REQUEST) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "account.oldPassword.noMatch")
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
        return Promise.reject(error);
      });
  }

  static async changeUserSettings({ body, intl }) {
    return Http.put(PRIVATE_API_ROUTES.USER_SETTINGS, body)
      .then((res) => {
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "account.notificationSetting.successMsg")
        );
        return Promise.resolve(res);
      })
      .catch((error) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(error);
      });
  }

  static async changeUserPassword({ body, intl }) {
    return Http.put(PRIVATE_API_ROUTES.CHANGE_USER_PASSWORD, body)
      .then(({ data }) => {
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "account.changeUserPassword.successMsg")
        );
        return Promise.resolve(data);
      })
      .catch((error) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );

        return Promise.reject(error);
      });
  }
}

export default MyAccountServices;
